import { customLocalStorage } from "@/utils/functions/customLocalStorage";
import { create } from "zustand";

const useGlobalStore = create<GlobalStoreStateType>()((set, get) => ({
  // users
  users: [],
  selectedUsers: [],
  stateByUserLabel: {},

  // users actions
  setUsers: (users: UserWithColor[]) => {
    set({ users: users.sort((u1, u2) => u1.id - u2.id) });
  },
  setSelectedUsers: (ids) => set(() => ({ selectedUsers: [...ids] })),
  removeUserFromSelectedUsers: (userId: number) =>
    set((state) => ({
      selectedUsers: state.selectedUsers.filter((selectedUser: number) => selectedUser !== userId),
    })),
  selectUser: (userId: number) => set((state) => ({ selectedUsers: [...state.selectedUsers, userId] })),

  // groups
  groups: [],
  setGroups: (groups: GroupType[]) => {
    set({ groups });
  },

  // traces
  traces: [],
  selectedTraceIds: [],
  isDeletingTraces: false,

  // traces actions
  setTraces: (traces: Trace[]) => {
    set({ traces });
  },
  setIsDeletingTraces: (value: boolean) => {
    set({ isDeletingTraces: value });
  },
  addSelectedTrace: (selectedTraceId: number) => {
    set({
      selectedTraceIds: [...get().selectedTraceIds, selectedTraceId],
    });
  },
  // Select a unique trace
  selectTrace: (selectedTraceId: number) => {
    set({
      selectedTraceIds: [selectedTraceId],
    });
  },
  // remove a trace from the list of selected traces
  deselectTrace: (selectedTraceId: number) => {
    set({
      selectedTraceIds: get().selectedTraceIds.filter((traceId: number) => traceId !== selectedTraceId),
    });
  },
  // deselect all traces
  deselectTraces: () => {
    set({ selectedTraceIds: [] });
  },

  // State actions
  lastStateRefreshDate: customLocalStorage.lastStateRefreshDate
    ? new Date(customLocalStorage.lastStateRefreshDate)
    : null,

  updateState: async (username, newState) => {
    const newRefreshDate = new Date();

    set({
      stateByUserLabel: { ...get().stateByUserLabel, [username]: newState },
      lastStateRefreshDate: newRefreshDate,
    });

    customLocalStorage.setLastStateRefreshDate(newRefreshDate.toISOString());
  },
}));

export default useGlobalStore;
